var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm._header)?_c('div',[_c('h5',[_vm._v("Bitte warten")]),_vm._v(" "),_c('h3',[_vm._v("Daten werden geladen…")])]):_c('content-placeholders',[_c('content-placeholders-heading',{attrs:{"img":true}}),_vm._v(" "),_c('content-placeholders-text',{attrs:{"lines":3}})],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ec6e7124","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/view-stack/components/loading.vue
// module id = C5Cu
// module chunks = 41 42 43